module.exports = __webpack_public_path__ + "static/img/red.f881bac0.png";